import { ref } from 'vue';
import { loadPersonalCars } from '../api';

const cars = ref({});
const loaded = ref(false);

const load = () => {
    loadPersonalCars().then(res => {
        cars.value = res.items || [];
        loaded.value = true;
    });
}

export default function usePersonalCars ()
{
    return {
        loaded,
        load,
        cars,
    };
}
